var _circle, _circle2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.7129,
    cy: 45.5,
    r: 44.5,
    stroke: "#1FC16B",
    strokeOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.7129,
    cy: 45.5,
    r: 40,
    fill: "#1FC16B",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.3792 47.1667V35.5001C62.3792 34.616 62.028 33.7682 61.4029 33.1431C60.7778 32.5179 59.93 32.1667 59.0459 32.1667H32.3792C31.4952 32.1667 30.6473 32.5179 30.0222 33.1431C29.3971 33.7682 29.0459 34.616 29.0459 35.5001V55.5001C29.0459 57.3334 30.5459 58.8334 32.3792 58.8334H45.7126",
    stroke: "#1FC16B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3792 37.1667L47.4292 46.6667C46.9147 46.9891 46.3198 47.1601 45.7126 47.1601C45.1054 47.1601 44.5104 46.9891 43.9959 46.6667L29.0459 37.1667",
    stroke: "#1FC16B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3799 57.1666L55.7132 60.4999L62.3799 53.8333",
    stroke: "#1FC16B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup21);
export default __webpack_public_path__ + "static/media/Group 21.cfd00863e91e006733705ab1352ebf58.svg";
export { ForwardRef as ReactComponent };